import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Row,
  Button,
  Collapse,
} from "reactstrap";
//redux
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// select
import Select from "react-select";
// componentes
import SectionComponent from "../../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../../components/SearchFilters";
import useDebounce from "../../../../utils/hooks/useDebounce";
import Pagination from "../../../../components/Paginationv3";
import ModalProducts from "./ModalProducts";
import WaitExport from "../../../../components/WaitExport";
import ModalListEmail from "./ModalListEmails";
import DeleteButton from "../../../../components/Buttons/DeleteButton";
import { createXlsx } from "./createXlsx";
import {
  documentDigits,
  formatAmount,
  formatDateTime,
  formatDocument,
  formatMobile,
  mailtoLink,
  whatsappLink,
} from "./formatters";
import CopyValue from "./CopyValue";
import ModalCancelSale from "./ModalCancelSale";
import ModalAttendees from "./ModalAttendees";
import ModalDetails from "../ModalDetails";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";
// service
import {
  getSalesConsolidated,
  deleteSalesConsolidated,
} from "../../../../utils/services/sales";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

function ConsolidatedSales(props) {
  const location = useLocation();
  // pesquisa
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  // exportar
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // alerta
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [confirmedDeleteAlert, setConfirmedDeleteAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  // obj para deletar e visualizar email
  const [selected, setSelected] = useState({});
  // listagem
  const [list, setList] = useState([]);
  // section component
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // modal
  const [modalProducts, setModalProducts] = useState(false);
  const [modalListEmail, setModalListEmail] = useState(false);
  const [modalAttendees, setModalAttendees] = useState(false);
  const [modalDetails, setModalDetails] = useState(false);
  // objeto selecionado para visualizar
  const [idSelected, setIdSelected] = useState("");
  // token
  const token = props.state.global_user_data.data.token;
  // loading
  const [isLoading, setIsLoading] = useState(false);
  // filtro
  const [activeFilter, setActiveFilter] = useState("email");
  const columnsFilter = [
    { name: "Email", value: "email", type: "text" },
    { name: "Tipo Pagamento", value: "payment", type: "text" },
    { name: "Status", value: "status", type: "text" },
    { name: "Data Criação", value: "created", type: "date" },
    { name: "Data Pagamento", value: "date", type: "date" },
  ];

  // tipo do input de busca (texto ou calendário), conforme a coluna filtrada
  const searchInputType =
    columnsFilter.find((column) => column.value === activeFilter)?.type ??
    "text";

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  function getTypePayment(type) {
    switch (type) {
      case "pix":
        return "Pix";

      case "credit_card":
        return "Cartão de Crédito";

      case "free":
        return "Gratuito";

      case "boleto":
        return "Boleto";

      default:
        return "";
    }
  }

  // texto e variante de badge "soft" do tema para cada status de pagamento
  function getStatusPayment(status) {
    switch (status) {
      case "pending":
        return {
          text: "Pendente",
          badge: "badge-soft-warning",
        };

      case "paid":
        return {
          text: "Pago",
          badge: "badge-soft-success",
        };

      case "canceled":
        return {
          text: "Cancelado",
          badge: "badge-soft-danger",
        };

      case "expired":
        return {
          text: "Expirado",
          badge: "badge-soft-secondary",
        };

      case "refunded":
        return {
          text: "Reembolsado",
          badge: "badge-soft-info",
        };

      default:
        return { text: "", badge: "badge-soft-secondary" };
    }
  }

  function exportList() {
    createXlsx({
      token,
      search: debouncedSearch,
      eventId: location.state.idEvent,
      limit: 100,
      columnSearch: activeFilter,
      countData,
      setFinishExport,
      setExportInProgress,
      getTypePayment,
      getStatusPayment,
    });

    setExportInProgress(true);
  }

  // cancela a venda selecionada e recarrega a lista
  function deleteSale() {
    setDeleting(true);
    deleteSalesConsolidated({
      jwt: token,
      idSale: selected.id,
    })
      .then((res) => {
        if (res.id) {
          setDeleteAlert(false);
          setConfirmedDeleteAlert(true);
          getListSales();
        } else setErrorAlert(true);
      })
      .catch(() => setErrorAlert(true))
      .finally(() => setDeleting(false));
  }

  function getListSales() {
    setIsLoading(true);
    getSalesConsolidated({
      token,
      search: debouncedSearch,
      eventId: location.state.idEvent,
      currentIndex,
      itemsPerPage,
      columnSearch: activeFilter,
    })
      .then((res) => {
        if (res.total !== "0") {
          setList(res.transactions);
          setCountData(Number(res.total));
        } else setList([]);
      })
      .finally(() => setIsLoading(false));
  }

  const paymentOptions = [
    {
      label: "Pix",
      value: "pix",
    },
    {
      label: "Cartão de Crédito",
      value: "credit_card",
    },
    {
      label: "Boleto",
      value: "boleto",
    },
    {
      label: "Gratuito",
      value: "free",
    },
  ];

  const statustOptions = [
    {
      label: "Pendente",
      value: "pending",
    },
    {
      label: "Pago",
      value: "paid",
    },
    {
      label: "Cancelado",
      value: "canceled",
    },
    {
      label: "Expirado",
      value: "expired",
    },
    {
      label: "Reembolsado",
      value: "refunded",
    },
  ];

  useEffect(() => {
    getListSales();
  }, [debouncedSearch, currentIndex, itemsPerPage]);

  return (
    <>
      {modalProducts && (
        <ModalProducts
          isOpen={modalProducts}
          toggle={() => setModalProducts(false)}
          idSelected={idSelected}
          token={token}
        />
      )}

      {modalListEmail && (
        <ModalListEmail
          isOpen={modalListEmail}
          toggle={() => setModalListEmail(false)}
          token={token}
          sale={selected}
        />
      )}

      {modalAttendees && (
        <ModalAttendees
          isOpen={modalAttendees}
          toggle={() => setModalAttendees(false)}
          token={token}
          sale={selected}
        />
      )}

      {modalDetails && (
        <ModalDetails
          isOpen={modalDetails}
          toggle={() => setModalDetails(false)}
          token={token}
          saleId={selected.id}
          sections={["Pagamento", "Comprador"]}
          onChanged={getListSales}
        />
      )}

      {exportInProgress && (
        <WaitExport
          isOpen={exportInProgress}
          name="Vendas Consolidadas"
          preposicao="das"
          finishExport={finishExport}
          setFinishExport={setFinishExport}
          setExportInProgress={setExportInProgress}
        />
      )}

      {deleteAlert && (
        <ModalCancelSale
          isOpen={deleteAlert}
          toggle={() => setDeleteAlert(false)}
          sale={selected}
          loading={deleting}
          onConfirm={deleteSale}
        />
      )}

      {confirmedDeleteAlert && (
        <SweetAlert
          success
          title="Confirmado"
          onConfirm={() => {
            setConfirmedDeleteAlert(false);
          }}
        >
          Cancelamento confirmado com sucesso!
        </SweetAlert>
      )}

      {errorAlert && (
        <SweetAlert
          error
          title="Erro ao tentar cancelar venda"
          onConfirm={() => {
            setErrorAlert(false);
          }}
        >
          Tente novamente em breve
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Vendas Consolidadas</CardTitle>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "50px",
            }}
          >
            <SectionComponent
              sectionName="Filtros"
              setIsOpen={setCollapseIsOpen}
              isOpen={collapseIsOpen}
            />
          </Row>

          <Collapse isOpen={collapseIsOpen}>
            <SearchFilters
              columns={columnsFilter}
              activeFilter={activeFilter}
              setActiveFilterHandle={setActiveFilterHandle}
            />
          </Collapse>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            {/* {activeFilter} */}
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                {activeFilter === "payment" || activeFilter === "status" ? (
                  <Select
                    onChange={(e) => setSearch(e.value)}
                    options={
                      activeFilter === "payment"
                        ? paymentOptions
                        : statustOptions
                    }
                    placeholder="Selecione"
                  />
                ) : (
                  <>
                    <input
                      type={searchInputType}
                      className="form-control"
                      placeholder="Pesquisar..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </>
                )}
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={searchInputType}
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />

              <Collapse isOpen={isOpen}>
                {countData > 0 && (
                  <Row className="mobile-btns-top" onClick={() => exportList()}>
                    <div>
                      <i className="mdi mdi-download me-1" aria-hidden="true" />
                      Exportar
                    </div>
                  </Row>
                )}
              </Collapse>
            </div>

            <div className="header-btns-container">
              {countData > 0 && (
                <Button
                  color="light"
                  className="btn-export events-button-add-lg"
                  onClick={() => exportList()}
                >
                  <i className="mdi mdi-microsoft-excel" aria-hidden="true" />
                  Exportar
                </Button>
              )}
            </div>
          </div>

          <div className="table-responsive border rounded-3 consolidated-sales-cards">
            <Table
              striped
              hover
              className="table mb-0 align-middle consolidated-sales-table"
            >
              <thead className="table-light align-top">
                <tr>
                  <th>Nome</th>
                  <th>CPF/CNPJ</th>
                  <th>Email Pagador</th>
                  <th>Celular</th>
                  <th>Endereço</th>
                  <th>Tipo Pagamento</th>
                  <th>Valor Total</th>
                  <th>Data Criação</th>
                  <th>Data Pagamento</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={11} />
                ) : (
                  list.map((e, i) => (
                    <tr key={i}>
                      <td data-label="Nome">{e.name}</td>
                      <td data-label="CPF/CNPJ" className="text-nowrap">
                        <CopyValue
                          value={formatDocument(e.document)}
                          copyValue={documentDigits(e.document)}
                        />
                      </td>
                      <td data-label="Email Pagador" className="mobile-stack">
                        <CopyValue value={e.email} href={mailtoLink(e.email)} />
                      </td>
                      <td data-label="Celular" className="text-nowrap">
                        <CopyValue
                          value={formatMobile(e.mobile)}
                          href={whatsappLink(e.mobile)}
                        />
                      </td>
                      <td data-label="Endereço">{e.address}</td>
                      <td data-label="Tipo Pagamento">
                        {getTypePayment(e.type)}
                      </td>
                      <td data-label="Valor Total" className="text-end text-nowrap">
                        {formatAmount(e.amount)}
                      </td>
                      <td
                        data-label="Data Criação"
                        className="text-end text-nowrap"
                      >
                        {formatDateTime(e.created_at)}
                      </td>
                      <td
                        data-label="Data Pagamento"
                        className="text-end text-nowrap"
                      >
                        {formatDateTime(e.updated_at)}
                      </td>
                      <td data-label="Status" className="text-nowrap">
                        <span
                          className={`badge rounded-pill px-3 py-1 ${
                            getStatusPayment(e.status).badge
                          }`}
                        >
                          {getStatusPayment(e.status).text}
                        </span>
                      </td>
                      <td data-label="Ações" className="actions-cell">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <i
                            className="bx bx-info-circle action-icon"
                            title="Detalhes da venda"
                            onClick={() =>
                              setSelected(e) > setModalDetails(true)
                            }
                          />
                          <i
                            className="mdi mdi-ticket-confirmation-outline action-icon ms-2"
                            title="Produtos"
                            onClick={() =>
                              setIdSelected(e.id) > setModalProducts(true)
                            }
                          />
                          <i
                            className="mdi mdi-account-group-outline action-icon ms-2"
                            title="Participantes"
                            onClick={() =>
                              setSelected(e) > setModalAttendees(true)
                            }
                          />
                          <i
                            className="mdi mdi-email-search action-icon mx-2"
                            title="Emails enviados"
                            onClick={() =>
                              setSelected(e) > setModalListEmail(true)
                            }
                          />
                          <DeleteButton
                            color="#74788d"
                            style={{ transition: "color 0.15s ease-in-out" }}
                            onMouseEnter={(ev) =>
                              (ev.currentTarget.style.color = "#f46a6a")
                            }
                            onMouseLeave={(ev) =>
                              (ev.currentTarget.style.color = "#74788d")
                            }
                            onClick={() =>
                              setSelected(e) > setDeleteAlert(true)
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div
        className="bottom-navigation consolidated-sales-pagination"
        style={{ justifyContent: "end" }}
      >
        <Pagination
          data={list}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(ConsolidatedSales);
